import styles from "./footer.module.css";
import logo from "../../assets/logo.svg";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  const date = new Date();
  const currentYear = date.getFullYear(4);
  return (
    <footer className={styles.footerSection}>
      <div className="sm:container mx-auto max-w-[1380px] px-4">
        <div className={styles.footerTop}>
          <h5 className={styles.headText}>DONATE BLOOD WHEN NEEDED</h5>
          <p className={styles.missionText}>
            Kindly register to donate. Appointments are available at some of our
            centres.
          </p>
          <div className={`${styles.bttn}`}>
            <Link to="/insights" className={`${styles.btn} hover:bg-red-400`}>
              👀 Insights
            </Link>
            <Link to="/contact-us" className={`${styles.btn} hover:bg-red-400`}>
              👋 Contact
            </Link>
          </div>
          <div className="flex justify-center items-center py-3 px-4">
            <Link to="/privacy" className={`hover:text-red-400`}>
              ⚙️ Terms of Service, 🔏 Privacy Policy and 🧑 User Agreement
            </Link>
          </div>
        </div>
        <div className="border border-white opacity-10 w-full absolute left-0"></div>
        <div className={styles.footerDetails}>
          <div className={styles.left}>
            <Link to="/home">
              <img src={logo} alt="RIBI logo" />
            </Link>
          </div>

          <div className={styles.center}>
            <p className="leading-normal">
              © {currentYear} RIBI. All Rights Reserved.{" "}
            </p>
          </div>

          <div className="flex flex-row space-x-4">
            <Link
              to="/"
              className="bg-[#f6655f] flex justify-center items-center rounded-full p-2"
            >
              <FaFacebookF size={24} color="white" />
            </Link>
            <Link
              to="/"
              className="bg-[#f6655f] flex justify-center items-center rounded-full p-2"
            >
              <FaTwitter size={24} color="white" />
            </Link>
            <Link
              to="/"
              className="bg-[#f6655f] flex justify-center items-center rounded-full p-2"
            >
              <FaLinkedinIn size={24} color="white" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
